export default "__VITE_ASSET__1bdd54e2__"